/*jslint node: true, browser: true*/

"use strict";

var dateBehaviour = require("pli/forms-knockoutcontrols-date").behaviours.date;
var ko = require("pli/knockout");
var pliObservable = require("pli/forms-knockoutcontrols");

var formattedBehaviour = require("../ko-behaviours-formatted");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ReminderViewModelExtensions static class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function ReminderViewModelExtensions() {
    this.recur = pliObservable(null, "N0", "numeric");
    this.recurUnit = ko.observable("M");
    this.start = pliObservable(null, null, "required", dateBehaviour, formattedBehaviour);
    this.completion = pliObservable(null, null, dateBehaviour, formattedBehaviour);
    this.extras.reminder = ko.computed(ReminderViewModelExtensions.prototype._computeReminder, this);
}


//---------------------------------------
ReminderViewModelExtensions.prototype.loadViewModel = function loadReminder(record) {
    this.recur.load(record.recur);
    this.recurUnit(record.recurUnit || "M");
    this.start.load(record.start);
    this.completion.load(record.completion);
};


//---------------------------------------
ReminderViewModelExtensions.prototype._computeReminder = function computeReminderValue() {
    /// <summary>
    /// Computes a readable string used to represent
    /// the reminder.
    /// </summary>
    this.start(); // create subscription to start
    var recur = this.recur(),
        recurUnit = this.recurUnit(),
        result;
    if (recur === 1) {
        result = "".concat(this.start.format()).concat(" every ").concat(recurUnit === "Y" ? "year" : "month");
    } else if (recur > 1) {
        result = "".concat(this.start.format()).concat(" every ").concat(this.recur.format()).concat(recurUnit === "Y" ? " years" : " months");
    } else {
        result = this.start.formatted();
    }
    return result;
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = {
    mixins: {
        initReminder: ReminderViewModelExtensions,
        loadReminder: ReminderViewModelExtensions.prototype.loadViewModel
    }
};



//////////////////
// WEBPACK FOOTER
// ./app/common-reminderextensions/reminderViewModelExtensions.js
// module id = 541
// module chunks = 49